import useCurrencyFormatters from "@hooks/useCurrencyFormatters"

import { faIcon } from "@utils/faIcon"

import { Badge } from "@atoms"

import { AmountOwedBadgeProps } from "./AmountOwedBadge.types"

const icon = faIcon({ name: "money-bills", style: "regular" })

export default function AmountOwedBadge(props: AmountOwedBadgeProps) {
    const { amountOwed, payables, unappliedCredit, size = "md" } = props

    const { formatCurrency } = useCurrencyFormatters()

    const formatted = formatCurrency(amountOwed ?? 0)
    // Without unapplied credit the amount owed is the payables, so the breakdown would only repeat it.
    const tooltip =
        Number(unappliedCredit ?? 0) > 0
            ? `Amount owed\n${formatted}\n${formatCurrency(payables ?? 0)} payables\n${formatCurrency(unappliedCredit ?? 0)} unapplied credit`
            : `Amount owed\n${formatted}`

    return (
        <Badge size={size} variant="icon" icon={icon} tooltip={tooltip}>
            {formatted}
        </Badge>
    )
}
